/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GovernanceProposalWithVotesRequest
 */
export interface GovernanceProposalWithVotesRequest {
    /**
     * 
     * @type {number}
     * @memberof GovernanceProposalWithVotesRequest
     */
    id: number;
}

export function GovernanceProposalWithVotesRequestFromJSON(json: any): GovernanceProposalWithVotesRequest {
    return GovernanceProposalWithVotesRequestFromJSONTyped(json, false);
}

export function GovernanceProposalWithVotesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GovernanceProposalWithVotesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function GovernanceProposalWithVotesRequestToJSON(value?: GovernanceProposalWithVotesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


